import WellsContent from "./WellsContent/WellsContent"
import classes from './Wells.module.scss'

const Wells = () => {

    return (
        <div className={classes.projectsContainer}>
                <WellsContent/>
        </div>
    )
}

export default Wells